(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 3255:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./src/components/index.ts + 74 modules
var components = __webpack_require__(9283);
// EXTERNAL MODULE: ./src/lib/utils.ts
var utils = __webpack_require__(9086);
// EXTERNAL MODULE: ../../node_modules/ramda/es/internal/_curry2.js
var _curry2 = __webpack_require__(7652);
// EXTERNAL MODULE: ../../node_modules/ramda/es/internal/_dispatchable.js + 1 modules
var _dispatchable = __webpack_require__(893);
// EXTERNAL MODULE: ../../node_modules/ramda/es/internal/_map.js
var _map = __webpack_require__(7512);
// EXTERNAL MODULE: ../../node_modules/ramda/es/internal/_reduce.js + 3 modules
var _reduce = __webpack_require__(2111);
// EXTERNAL MODULE: ../../node_modules/ramda/es/internal/_xfBase.js
var _xfBase = __webpack_require__(3634);
;// CONCATENATED MODULE: ../../node_modules/ramda/es/internal/_xmap.js



var XMap =
/*#__PURE__*/
function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XMap.prototype['@@transducer/init'] = _xfBase/* default.init */.Z.init;
  XMap.prototype['@@transducer/result'] = _xfBase/* default.result */.Z.result;

  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap =
/*#__PURE__*/
(0,_curry2/* default */.Z)(function _xmap(f, xf) {
  return new XMap(f, xf);
});

/* harmony default export */ var internal_xmap = (_xmap);
// EXTERNAL MODULE: ../../node_modules/ramda/es/curryN.js + 1 modules
var curryN = __webpack_require__(8269);
// EXTERNAL MODULE: ../../node_modules/ramda/es/keys.js + 1 modules
var keys = __webpack_require__(7179);
;// CONCATENATED MODULE: ../../node_modules/ramda/es/map.js







/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */

var map =
/*#__PURE__*/
(0,_curry2/* default */.Z)(
/*#__PURE__*/
(0,_dispatchable/* default */.Z)(['fantasy-land/map', 'map'], internal_xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return (0,curryN/* default */.Z)(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });

    case '[object Object]':
      return (0,_reduce/* default */.Z)(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, (0,keys/* default */.Z)(functor));

    default:
      return (0,_map/* default */.Z)(fn, functor);
  }
}));

/* harmony default export */ var es_map = (map);
;// CONCATENATED MODULE: ../../node_modules/ramda/es/evolve.js

/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */

var evolve =
/*#__PURE__*/
(0,_curry2/* default */.Z)(function evolve(transformations, object) {
  var result = object instanceof Array ? [] : {};
  var transformation, key, type;

  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
  }

  return result;
});

/* harmony default export */ var es_evolve = (evolve);
;// CONCATENATED MODULE: ./src/lib/serializers/job.ts


var serialize = es_map(es_evolve({
    activity: {
        start: utils/* toISO */.Vn,
        end: (0,utils/* optional */.jt)(utils/* toISO */.Vn)
    }
}));
var deserialize = es_map(es_evolve({
    activity: {
        start: utils/* fromISO */.Hf,
        end: (0,utils/* optional */.jt)(utils/* fromISO */.Hf)
    }
}));

;// CONCATENATED MODULE: ./src/lib/serializers/education.ts


var education_serialize = es_map(es_evolve({
    started: utils/* toISO */.Vn,
    ended: (0,utils/* optional */.jt)(utils/* toISO */.Vn)
}));
var education_deserialize = es_map(es_evolve({
    started: utils/* fromISO */.Hf,
    ended: (0,utils/* optional */.jt)(utils/* fromISO */.Hf)
}));

;// CONCATENATED MODULE: ./src/lib/serializers/course.ts


var periodSerializer = es_evolve({
    started: utils/* toISO */.Vn,
    ended: (0,utils/* optional */.jt)(utils/* toISO */.Vn)
});
var course_serialize = es_map(es_evolve({
    courses: es_map(periodSerializer)
}));
var course_deserialize = es_map(es_evolve({
    courses: es_map(es_evolve({
        started: utils/* fromISO */.Hf,
        ended: (0,utils/* optional */.jt)(utils/* fromISO */.Hf)
    }))
}));

// EXTERNAL MODULE: ../../node_modules/ramda/es/compose.js + 7 modules
var compose = __webpack_require__(745);
// EXTERNAL MODULE: ../../node_modules/ramda/es/pick.js
var pick = __webpack_require__(1185);
;// CONCATENATED MODULE: ./src/lib/serializers/resume.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var contactsSerializer = es_map(compose/* default */.Z(pick/* default */.Z([
    'link',
    'name',
    'username',
    'icon'
]), es_evolve({
    icon: function(icon) {
        return (icon === null || icon === void 0 ? void 0 : icon.name) ? _objectSpread({}, icon) : {};
    }
})));
var resume_serialize = es_evolve({
    bio: function(bio) {
        return bio !== null && bio !== void 0 ? bio : null;
    },
    contacts: contactsSerializer,
    jobs: serialize,
    educations: education_serialize,
    courses: course_serialize
});

;// CONCATENATED MODULE: ./src/lib/serializers/index.ts










// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 27 modules
var esm = __webpack_require__(5849);
;// CONCATENATED MODULE: ./src/pages/index.tsx




var Home = function(param1) {
    var _resume = param1.resume, jobs = _resume.jobs, educations = _resume.educations, courses = _resume.courses, skills = _resume.skills;
    var t = (0,esm/* useTranslation */.$G)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col print:gap-5 gap-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                title: t('sections.experience'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Timeline */.TY, {
                    jobs: deserialize(jobs)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                title: t('sections.education'),
                children: education_deserialize(educations).map(function(param) {
                    var title = param.title, name = param.institution.name, ended = param.ended;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* Education */.TS, {
                        title: title,
                        educations: [
                            {
                                name: name,
                                end: ended
                            }
                        ]
                    }, title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                title: t('sections.courses_trainings'),
                children: course_deserialize(courses).map(function(param2) {
                    var trainings = param2.courses, institution = param2.institution;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* Education */.TS, {
                        title: institution,
                        educations: trainings.map(function(param) {
                            var title = param.title, ended = param.ended;
                            return {
                                end: ended,
                                name: title
                            };
                        })
                    }, institution);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                title: t('sections.skills'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Skills */.nA, {
                    skills: skills
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3255); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);